import React, { useEffect, useRef, useState } from 'react';
import '../styles/meet-the-expert.css';

interface MeetTheExpertProps {
  name?: string;
  title?: string;
  company?: string;
  imageUrl?: string;
  ctaButtons?: Array<{
    text: string;
    href: string;
  }>;
}

const MeetTheExpert: React.FC<MeetTheExpertProps> = ({
  name = "NATALIE ANTEKELIAN",
  title = "PRINCIPAL ATTORNEY", 
  company = "MUSE LEGAL",
  imageUrl = "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=400&h=500&fit=crop&crop=face",
  ctaButtons = [
    { text: "SCHEDULE CONSULTATION", href: "#contact" },
    { text: "VIEW PROFILE", href: "#profile" },
    { text: "CASE STUDIES", href: "#cases" }
  ]
}) => {
  const [isVisible, setIsVisible] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    if (containerRef.current) {
      observer.observe(containerRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <div ref={containerRef} className="meet-expert-container">
      {/* Header Text with Overlapping Effect */}
      <div className={`meet-expert-header ${isVisible ? 'animate-in' : ''}`}>
        <div className="meet-expert-text-small">MEET THE</div>
        <div className="meet-expert-text-large">expert</div>
      </div>

      {/* Central Photo */}
      <div className={`meet-expert-photo-container ${isVisible ? 'animate-in' : ''}`}>
        <div className="meet-expert-photo">
          <img 
            src={imageUrl} 
            alt={name}
            className="meet-expert-image"
            onError={(e) => {
              console.log('Image failed to load:', imageUrl);
              e.currentTarget.src = 'https://images.unsplash.com/photo-1494790108755-2616b612b786?w=400&h=500&fit=crop&crop=face';
            }}
          />
        </div>
      </div>

      {/* Bottom CTA Section */}
      <div className={`meet-expert-cta-section ${isVisible ? 'animate-in' : ''}`}>
        <div className="meet-expert-info">
          <div className="meet-expert-name">{name}</div>
          <div className="meet-expert-title">{title}</div>
          <div className="meet-expert-company">{company}</div>
        </div>
        
        <div className="meet-expert-cta-buttons">
          {ctaButtons.map((button, index) => (
            <a
              key={index}
              href={button.href}
              className="meet-expert-cta-button"
              style={{ animationDelay: `${0.2 + index * 0.1}s` }}
            >
              {button.text}
            </a>
          ))}
        </div>
      </div>
    </div>
  );
};

export default MeetTheExpert;

